import React from 'react'

import { HTMLContent } from '../Content'

import './styles.css'

export const TextPage = ({ content, heading, subheading }: any) => {
  return (
    <div className="layout-body">
      <div className="grid mt-5 mb-3">
        <div className="col">
          <div>
            <h1 className="text-center">{heading}</h1>
          </div>
          <div>
            <h4 className="text-center mt-0-5">{subheading}</h4>
          </div>
          <div className="text-center">
            <div className="hr mb-4 xs-mb-4 mt-6 xs-mt-4" />
          </div>
        </div>
      </div>
      <div className="grid-center">
        <div className="col-8_sm-12 text-page-content">
          <HTMLContent content={content} />
        </div>
      </div>
    </div>
  )
}
